import { Buttons, FlexContainer, Text, useResize } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import { handleRedirectUser } from 'Containers/Dashboard/components/PreviousYearBanner/utils';
import { ZeroBannerProps } from './types';

const ZeroBanner = ({ data, isRequest }: ZeroBannerProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.PY);
  const { isMobile } = useResize();
  return (
    <FlexContainer
      direction={isMobile ? 'row' : 'column'}
      align={isMobile ? 'center' : 'flex-start'}
      justify="space-between"
      gap="dimension_08"
    >
      {!isMobile && (
        <>
          <Text type="headline" size="S_L_S" color="dark">
            {t('PreviousYearBanner.title')}
          </Text>
          <Text type="paragraphs" size="S_L_L" color="dark">
            {t('PreviousYearBanner.mobile.title')}
          </Text>
        </>
      )}
      <FlexContainer direction="column" gap="dimension_08">
        <Text type="paragraphs" size="M_L_S" color="dark">
          {t('PreviousYear.result.zero.title')}
        </Text>
        <Text type="paragraphs" size="XS_M_M" color="grey">
          {t('PreviousYear.result.zero.description')}
        </Text>
      </FlexContainer>
      <Buttons.Classic
        mode="cold"
        label={t('PreviousYearBanner.zero.button')}
        size={isMobile ? 'xs' : 's'}
        onClick={() => handleRedirectUser(data, isRequest)}
      />
    </FlexContainer>
  );
};

export default ZeroBanner;
